var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.115 13H15.885C16.0383 13 16.1793 12.936 16.308 12.808C16.436 12.6793 16.5 12.5383 16.5 12.385V3H4.5V12.385C4.5 12.5383 4.564 12.6793 4.692 12.808C4.82067 12.936 4.96167 13 5.115 13ZM5.115 14C4.655 14 4.271 13.846 3.963 13.538C3.65433 13.2293 3.5 12.845 3.5 12.385V1.615C3.5 1.155 3.65433 0.771 3.963 0.463C4.271 0.154333 4.655 0 5.115 0H15.885C16.345 0 16.729 0.154333 17.037 0.463C17.3457 0.771 17.5 1.155 17.5 1.615V12.385C17.5 12.845 17.346 13.2293 17.038 13.538C16.7293 13.846 16.345 14 15.885 14H5.115ZM2.115 17C1.655 17 1.271 16.846 0.963 16.538C0.654333 16.2293 0.5 15.845 0.5 15.385V3.615H1.5V15.385C1.5 15.5383 1.564 15.6793 1.692 15.808C1.82067 15.936 1.96167 16 2.115 16H13.885V17H2.115Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupingSmall);
export default __webpack_public_path__ + "static/media/grouping-small.c4a8c2da3a80d5e151f5f72ce2743278.svg";
export { ForwardRef as ReactComponent };